import { money } from "@/lib/currency";

export const LineAddons = ({ addons, variants, cur, className = "text-[#6B6560]" }) => (
  <>
    {variants?.length > 0 && (
      <span data-testid="line-variants" className={`block text-xs ${className}`}>{variants.map((v) => v.name).join(" · ")}</span>
    )}
    {addons?.length > 0 && (
      <span data-testid="line-addons" className={`block text-xs ${className}`}>
        {addons.map((a) => `+ ${a.name}${a.price ? ` (${money(a.price, cur)})` : ""}`).join(", ")}
      </span>
    )}
  </>
);
